import { create } from 'zustand';
import apiClient from '../api/client';

// Синтетический идентификатор dashboard-канала (password-вход),
// совпадает с DASHBOARD_ADMIN_ID на backend.
export const DASHBOARD_ADMIN_ID = 'dashboard-admin';

interface AuthState {
  mode: 'dashboard' | 'embed' | 'anonymous';
  userId: string | null;
  isAuthenticated: boolean;
  isAdmin: boolean;
  isLoading: boolean;
  loginDashboard: (password: string) => Promise<boolean>;
  logoutDashboard: () => Promise<void>;
  // Embed: userId берётся из aseller-токена (_id) / Hub user.id и шлётся на
  // backend заголовком X-User-Id. Обмена на Keycloak JWT нет.
  setEmbedUser: (userId: string) => void;
  resetAuth: () => void;
  checkDashboardAuth: () => Promise<void>;
}

const ANONYMOUS_STATE = {
  mode: 'anonymous' as const,
  userId: null,
  isAuthenticated: false,
  isAdmin: false,
};

export const useAuthStore = create<AuthState>((set) => ({
  ...ANONYMOUS_STATE,
  isLoading: true,

  loginDashboard: async (password: string) => {
    try {
      const { data } = await apiClient.post('/api/admin/login', { password }, { withCredentials: true });
      if (data.success) {
        set({ mode: 'dashboard', userId: DASHBOARD_ADMIN_ID, isAuthenticated: true, isAdmin: true });
        return true;
      }
      return false;
    } catch {
      return false;
    }
  },

  logoutDashboard: async () => {
    try {
      await apiClient.post('/api/admin/logout', {}, { withCredentials: true });
    } catch { /* ignore */ }
    set(ANONYMOUS_STATE);
  },

  setEmbedUser: (userId: string) => {
    set({
      mode: 'embed',
      userId,
      isAuthenticated: true,
      isAdmin: false,
    });
  },

  resetAuth: () => {
    set(ANONYMOUS_STATE);
  },

  checkDashboardAuth: async () => {
    set({ isLoading: true });
    try {
      const { data } = await apiClient.get('/api/admin/check', { withCredentials: true });
      if (data.authenticated) {
        set({ mode: 'dashboard', userId: DASHBOARD_ADMIN_ID, isAuthenticated: true, isAdmin: true, isLoading: false });
      } else {
        set({ isLoading: false });
      }
    } catch {
      set({ isLoading: false });
    }
  },
}));
